import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Item as GridToolbarItem,
} from "devextreme-react/data-grid";
import { buildDxFilters, FillFilters, loadDatasource, loadLookupFromStaticDataSource } from '../../../common/Utils'
import { SearchLayout } from './Layout';
import { LotStatus } from '../../../const/Lookup';
import { IM } from '../../../const/constants';
import LotList from '../../common/lists/LotList';
import { set } from 'lodash';
import '../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [selectedRow, setSelectedRow] = useState(null);
    const rowId = useRef(null);
    const initialFormFields = {
        RowId: null,
        KeySequence: null,
        CreationDateTime: null,
        CreationUserId: null,
        LastUpdateDateTime: null,
        LastUpdateUserId: null,
        CompanyId: null,
        Module: props.module??null,
        RIdentity: props.rIdentity??null,
        RecordType: null,
        RItem: null,
        LotCode: null,
        Description1: null,
        Description2: null,
        Status: null,
        Comment: null,
        RVendor: null,
        RouteCode: null,
        RLocation: null,
        LotSizeCode: null,
        LotProjectionCode: null,
        LotUnitUomFlag: null,
        LotUomDefault: null,
        LotUnitsPerItemUnit: null,
        RoyaltyFlag: null,
        RoyaltyUnitCost: null,
        RoyaltyUnitPrice: null,
        RoyaltyAddToPriceFlag: null,
        StageFlag: null,
        ReorderInventoryMinimumQty: null,
        ReorderInventoryMaximumQty: null,
        ReorderQuantityEoqCalculated: null,
        ReorderQuantityOrderMultiple: null,
        ReorderSafetyQuantity: null,
        ReorderLeadTime: null,
        CostBasisMethodFlag: null,
        AverageCost: null,
        StandardCost: null,
        RPriceTable: null,
        CorePrice: null,
        MaximumPriceLevelForDiscount: null,
        TradeDiscountOnSpecialPriceAr: null,
        EarlyPayDiscountFlag: null,
        CostAllocationFactor: null,
        DateIntroduced: null,
        ReorderQuantityEntered: null,
        DateAvailable: null,
        ReorderMethodFlag: null,
        DateExpiration: null,
        ReorderMinimumDaysOnHand: null,
        UserDefinedCode1: null,
        ReorderMaximumDaysOnHand: null,
        UserDefinedCode2: null,
        ClassCode: null,
        UserDefinedCode3: null,
        SubClassCode: null,
        UserDefinedCode4: null,
        RProductCategory: null,
        UserDefinedCode5: null,
        ROemManufactureId: null,
        UserDefinedCode6: null,
        UserDefinedCode7: null,
        VendorItemCode: null,
        UserDefinedCode8: null,
        PhysicalCountCode: null,
        UserDefinedCode9: null,
        OemManufacturerCode: null,
        UserDefinedCode10: null,
        UserDefinedReference1: null,
        UserDefinedReference2: null,
        UserDefinedReference3: null,
        UserDefinedReference4: null,
        UserDefinedReference5: null,
        UserDefinedReference6: null,
        UserDefinedReference7: null,
        UserDefinedReference8: null,
        UserDefinedReference9: null,
        UserDefinedReference10: null,
        UserDefinedDate1: null,
        UserDefinedDate2: null,
        UserDefinedDate3: null,
        UserDefinedDate4: null,
        UserDefinedDate5: null,
        UserDefinedDate6: null,
        UserDefinedDate7: null,
        UserDefinedDate8: null,
        UserDefinedDate9: null,
        UserDefinedDate10: null,
        UserDefinedQuantity1: null,
        UserDefinedQuantity2: null,
        UserDefinedQuantity3: null,
        UserDefinedQuantity4: null,
        UserDefinedQuantity5: null,
        UserDefinedQuantity6: null,
        UserDefinedQuantity7: null,
        UserDefinedQuantity8: null,
        UserDefinedQuantity9: null,
        UserDefinedQuantity10: null,
        InventoryUnitUom: null,
        PiecesPerUnitUom: null,
        PiecesPerUnitQuantity: null,
        UnitsPerPackageUom: null,
        UnitsPerPackageQuantity: null,
        PackagesPerShippingUnitUom: null,
        PackagesPerShippingUnitQty: null,
        UnitVolumeUom: null,
        UnitVolumeQuantity: null,
        UnitAreaUom: null,
        UnitAreaQuantity: null,
        UnitValueUom: null,
        NetWeightUom: null,
        NetWeightQuantity: null,
        GrossWeightUom: null,
        UnitValueQuantity: null,
        GrossWeightQuantity: null,
        OnHand: null,
        InOrdered: null,
        OutOrdered: null,
        InReceiving: null,
        OutShipped: null,
        InBackOrder: null,
        OutBackOrder: null,
        InUnavailable: null,
        OutUnavailable: null,
        InFuture: null,
        OutFuture: null,
        Available: props.Available??null,
        NetAvailable: null,
        StorageBillingStartDate: null,
        StorageBillingEndDate: null,
        RRateSchedule: null,
        PopupMessage: null,
        LastCost: null,
        Size1: null,
        RBuyer: null,
        Size2: null,
        StorageBilledDateLast: null,
        StorageBilledDateNext: null,
        PriceSource: null,
        PriceMethod: null,
        CalcMethod: null,
        PriceLevelA: null,
        PriceLevelB: null,
        PriceLevelC: null,
        PriceLevelD: null,
        PriceLevelE: null,
        RGlDepartment: null,
        RGlFund: null,
        RCaJob: null,
        PriceBasis: null,
        RFees: null,
        ItemsUpcCode: null,
        RfReceiptValidation: null,
        RfShipmentValidation: null,
        InTransactionNumber: null,
        DateLastReceipt: null,
        RParticipant: null,
        CommissionBasis: null,
        CommissionAmount: null,
        RoundingMethod: null,
        RoundingFactor: null,
        AlternateStandardCost: null,
        AlternateAverageCost: null,
        AlternateLastCost: null,
        PrevStorageBilledDateLast: null,
        PrevStorageBilledDateNext: null,
        RecurringStorage: null,
        ProgressiveCurrentRate: null,
        ProgressiveLastRate: null,
        ProgressivePreviousLastRate: null,
        ProgressiveBillingCount: null,
        RLotSource: null,
        OversellPercentage: null,
        SaleMaxQuantity: null,
        Record: null,
        ItemCode: null,
        RProfile: null,
        RWarehouse: null,
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const [triggerLoadData, setTriggerLoadData] = useState({
        filters:initialFormFields,
        filterTypes:SearchLayout
    });

    const handelEditClick = () => {
        const buttonUrl = "/om/codes/lot-data-entry-edit?id=" + selectedRow.RowId;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );
    const handleSearch = (e) => {
        e.event.stopPropagation();
        setTriggerLoadData({
            filters: formFields,
            filterTypes: SearchLayout
        });
    }

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setTriggerLoadData({
            filters: initialFormFields,
            filterTypes: SearchLayout
        });
    }

    const handleFormLoad = useCallback(() => {
        loadLookupFromStaticDataSource("Status", LotStatus, formFields, formRefs);
    }, []);
    const handleFieldChange = useCallback((name, value) => {
        // console.log(name, value);
    }, []);

    const customToolbarItems = [
        <GridToolbarItem location="before" key="edit">
            <Button
                disabled={selectedRow ? false : true}
                onClick={handelEditClick}
                type="default"
                text="Edit"
            ></Button>
        </GridToolbarItem>,
        <GridToolbarItem location="before" key="create">
            <Link to="/om/codes/lot-data-entry-create">
                <Button
                    type="default"
                    className="gridTopButton"
                    text="Create"
                />
            </Link>
        </GridToolbarItem>
    ];
    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Lot Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='FE0B20CA-6581-4599-A0C9-6DF8A19FC297'
                                layoutName='OMLotDataEntrySearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <LotList triggerLoadData={triggerLoadData} toolbarItems={props.toolbarItems??customToolbarItems} setSelectedRow={(data)=>{
                        setSelectedRow(data);
                     if(typeof props.setSelectedRow === 'function')
                        props.setSelectedRow(data)
                        }} selectionMode="multiple" gridClassName="search-page-grid"/>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(List);